
import { Image, StyleSheet, TouchableOpacity, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef, useState } from "react";

import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

import BottomSheetModal from "components/BottomSheetModal";

import { Colors } from "colors";
import { Images } from "assets";
import {Svg} from "assets/svg";
import VText from "components/VText";
import { useGlobalSearchParams } from "expo-router";


export default React.forwardRef((props, ref) => {
    const { height, width } = useWindowDimensions();
    const _bottomSheetRef = useRef();
    const local = useGlobalSearchParams();

    React.useImperativeHandle(ref, () => ({ show, hide }), []);

    const show = () => {
        _bottomSheetRef?.current?.show();
    };

    const hide = () => {
        _bottomSheetRef?.current?.hide();
    };

    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={() => _bottomSheetRef?.current?.hide()}
            >
                <TouchableOpacity
                    style={{
                        width: wp(430),
                        height: hp(131),
                        height: "auto",
                        backgroundColor: "#fff",
                        cursor: "auto",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: spV(20),
                    }}
                    activeOpacity={1}
                >
                    <View style={{flexDirection: "column", alignItems: "center", justifyContent: "center",gap:spV(15)}}>
                        <Image source={require("assets/BlackCircleCheck.svg")} style={styles.image} resizeMode="contain" />
                        <VText style={styles.modalTitle}>Products Added to Bag</VText>
                    </View>
               
                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        borderRadius: 8,
        width: wp(309),
    },
    image: {
        width: wp(40),
        height: hp(40),

    },
    modalTitle: {
        fontSize: fp(20),
        fontWeight: "380",
        color: Colors.black,
    },
});
